import { HttpPlanOrderList, HttpExportBillManage, HttpChangePlanOrderStatus, HttpPlanOrderCount, HttpChangePlanOrderReprocess, HttpChangePlanOrderIgnoreError } from '@/service/salesreturns';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compDetail from './detail';
import compPhoto from '../photo.vue'
import compChangeTime from './changetime.vue'
import mixin from '../mixin';

export default {
    mixins: [TableList, mixin],
    components: {
        compDetail,
        compPhoto,
        compChangeTime,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: {
                show: true,
                // key: 'EQ_saleReturnPlanStatus'
            },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
            formData: {
                search: {
                    quanbu: 0
                }
            },
            exportdata: {},
            spanTabs: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpPlanOrderList,
        interceptRequest(params) {
            if (params.search.quanbu === 0) {
                params.search.EQ_saleReturnPlanStatus = ''
            }
            if (params.search.daishenhe === 0) {
                params.search.EQ_saleReturnPlanStatus = '5'
            }
            if (params.search.shenhebohui === 0) {
                params.search.EQ_saleReturnPlanStatus = '20'
            }
            if (params.search.daishouhuo === 0) {
                params.search.EQ_saleReturnPlanStatus = '30'
            }
            if (params.search.shouhuozhong === 0) {
                params.search.EQ_saleReturnPlanStatus = '10'
            }
            if (params.search.daiqueren === 0) {
                params.search.EQ_confirmStatus = '5'
            }
            if (params.search.yichang === 0) {
                params.search.NE_errorStatus = '99999'
            }
            if (params.search.IN_sourceSystem == 1) {
                params.search.IN_sourceSystem = [1, 8]
            }
            delete params.search.quanbu;
            delete params.search.daishenhe;
            delete params.search.shenhebohui;
            delete params.search.daishouhuo;
            delete params.search.shouhuozhong;
            delete params.search.daiqueren;
            delete params.search.yichang;

            this.exportdata = params
            return params
        },
        spanAjaxRequest: () => {
            return HttpPlanOrderCount({
                isManage: true
            })
        },
        handleOperates(params, type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpExportBillManage, this.exportdata, { executor: 'request', download: true });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeids: params,
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "salesreturnsPlanmanageDetail",
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "queryAfterSaleOrder":
                    var erpUrl = process.env.VUE_APP_ERP + '/home/aftersales/saleorders/update/query?id=' + params.sourceId + '&contextId=' + params.organizationId;
                    window.open(erpUrl, '_blank');
                    break;
                case 'approve':
                    this.operate = {
                        show: true,
                        title: "审核",
                        langKey: "global.common.approve",
                        alert: "success",
                        showDesc: false,
                        width: "middle",
                        params: { id: params, status: 30, },
                        ajaxRequest: HttpChangePlanOrderStatus,
                        formdata: [
                            {
                                tag: "vRadio",
                                key: "status",
                                labelWidth: 'auto',
                                default: 30,
                                span: 24,
                                label: "审核",
                                options: [{
                                    trueValue: 30,
                                    label: '审核通过',
                                }]
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required: false
                            }
                        ],
                    }
                    break;
                case 'receiveComplete':
                    this.operate = {
                        show: true,
                        title: "收货完成",
                        alert: "success",
                        width: "middle",
                        showDesc: false,
                        params: { id: params, status: 70 },
                        ajaxRequest: HttpChangePlanOrderStatus,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                            }
                        ],
                    }
                    break;
                case "rehandle":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: '重处理',
                        ajaxRequest: HttpChangePlanOrderReprocess,
                        showDesc: true,
                    }
                    break;
                case "ignoreAbnormal":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: '忽略异常',
                        ajaxRequest: HttpChangePlanOrderIgnoreError,
                        showDesc: true,
                    }
                    break;
                case "image":
                    this.operate = {
                        show: true,
                        title: this.$t('global.photo.info', { defaultValue: '照片信息' }),
                        component: "compPhoto",
                        currentUrl: params.url,
                        urlList: params.urlList,
                        showFooter: false,
                        width: 1200,
                    }
                    break;
                case "changeTime":
                    this.operate = {
                        show: true,
                        title: "修改最晚确认时间",
                        alert: "primary",
                        width: "middle",
                        showDesc: false,
                        component: "compChangeTime",
                        showFooter: false,
                        ids: params,
                    }
            }
        },
        getOperateNodeMap(row) {
            const { id, saleReturnPlanStatus, errorStatus } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: true,
                params: id,
                operate: 'query'
            },
            {
                label: this.$t('global.common.approve', { defaultValue: "审核" }),
                show: saleReturnPlanStatus == 5 && this.handleAuth('fbb.returnplan.review'),
                params: id,
                operate: 'approve'
            },
            {
                label: this.$t('', { defaultValue: "收货完成" }),
                show: saleReturnPlanStatus == 10,
                params: id,
                operate: 'receiveComplete'
            },
            {
                label: "重处理",
                show: errorStatus !== 99999,
                params: id,
                operate: 'rehandle'
            },
            {
                label: "忽略异常",
                show: errorStatus !== 99999,
                params: id,
                operate: 'ignoreAbnormal'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getUserManageWarehouseList', 'getBillcusWareList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    show: this.handleAuth('fbb.returnplan.export'),
                    operate: "export",
                },
                {
                    name: "修改最晚确认时间",
                    show: this.handleAuth('fbb.returnplan.updatetime') && this.formData.search.daiqueren == 0,
                    operate: "changeTime",
                    batch: true
                },
            ]
        },
        TabsData() {
            return [
                {
                    name: this.$tc('fbb.sales.sales_status', 0, { defaultValue: '全部' }),
                    key: 'quanbu',
                    val: 0,
                    spanKey: "allQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待审核' }),
                    key: 'daishenhe',
                    val: 0,
                    spanKey: "submittedQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '审核拒回' }),
                    key: 'shenhebohui',
                    val: 0,
                    spanKey: "rejectQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待收货' }),
                    key: 'daishouhuo',
                    val: 0,
                    spanKey: "examineedQty"
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货中' }),
                    key: 'shouhuozhong',
                    val: 0,
                    spanKey: "examineingQty"
                },
                {
                    name: this.$t('fbb.alloment.confirm', { defaultValue: "待确认" }),
                    key: 'daiqueren',
                    val: 0,
                    spanKey: "confirmedQty"
                },
                {
                    name: this.$t('', { defaultValue: '异常' }),
                    key: 'yichang',
                    val: 0,
                    spanKey: "errorQty"
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 218px;'
            return [
                {
                    label: this.$t('fbb.sales_return.planbill', { defaultValue: "销售退货计划单号" }),
                    key: 'EQ_saleReturnPlanNo',
                    show: true,
                    tag: 'vInput',
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_orgWarehouseCode',
                    tag: 'Select',
                    options: this.getUserManageWarehouseList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    show: true,
                    props: {
                        filterable: true,
                    },
                    style: 'width: 172px; margin-right:27px',
                },
                {
                    label: this.$t('', { defaultValue: "收货状态" }),
                    key: 'IN_saleReturnPlanStatus',
                    tag: 'Select',
                    options: this.getPlanManageOrderStatus.slice(1),
                    style: widthStyle
                },
                {
                    label: this.$t('', { defaultValue: "确认状态" }),
                    key: 'IN_confirmStatus',
                    tag: 'Select',
                    options: this.getConfirmStatus,
                    style: widthStyle
                },
                {
                    label: this.$t('', { defaultValue: '来源类型' }),
                    tag: 'Select',
                    key: 'IN_sourceSystem',
                    options: this.searchSourceSystem,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.sourceNo', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.sourceNo', { defaultValue: "关联订单号" }),
                    key: 'EQ_saleOrderNo',
                    tag: 'vInput',
                    style: widthStyle
                },
                {
                    label: this.$t('', { defaultValue: "退货Tacking" }),
                    key: 'EQ_returnTrackingNo',
                    tag: 'vInput',
                    show: true,
                    style: 'width: 172px; margin-right:20px',
                },
                // {
                //     label: "是否拍照",
                //     tag: "Select",
                //     key: "EQ_hasPicture",
                //     options: [
                //         {
                //             label: "是",
                //             value: 1
                //         },
                //         {
                //             label: "否",
                //             value: 0
                //         }
                //     ],
                // },
                {
                    label: "建议处理方式",
                    tag: "Select",
                    key: "EQ_saleReturnPlanOrderItemEntityList.goodsReturnType",
                    options: [
                        {
                            label: "客户自提",
                            value: 0
                        },
                        {
                            label: "拍照确认",
                            value: 1
                        },
                        {
                            label: "销毁",
                            value: 2
                        }
                    ],
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'EQ_organizationId',
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inbound.errorcode', { defaultValue: "异常类型" }),
                    tag: 'Select',
                    key: 'EQ_errorStatus',
                    options: this.getErrorSimpleType1,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: '最晚确认时间',
                    tag: 'vDatepicker',
                    key: 'BT_lastConfirmTime',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    formName: 'id',
                    width: this.formData.search.daiqueren == 0 ? 60 : 0,
                    align: 'center'
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    width: 100,
                    key: 'organizationId',
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId)
                },
                {
                    title: this.$t('', { defaultValue: "退货计划单号" }) + '/' + this.$t('global.common.sourceNo', { defaultValue: "来源单号" }) + '/' + this.$t('global.common.saleOrderNo', { defaultValue: "关联订单号" }),
                    width: 250,
                    key: 'saleReturnPlanNo',
                    render: (h, { row }) => {
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')} class="color-link">{row.saleReturnPlanNo || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            <div>
                                <a v-show={row.sourceId} onClick={this.handleOperates.bind(this, { sourceId: row.sourceId, organizationId: row.organizationId }, 'queryAfterSaleOrder')}>{row.sourceNo || '--'}</a>
                                <div v-show={!row.sourceId}>{row.sourceNo || '--'}</div>
                            </div>
                            <div>{row.saleOrderNo || '--'}</div>
                            <div>
                                <Tooltip placement="top" content={this.$t('', { defaultValue: '待确认' })}>
                                    <span v-show={row.confirmStatus === 5} class="order-active-span margin-right-5" style="cursor: pointer;">{this.$t('', { defaultValue: '待' })}</span>
                                </Tooltip>
                                <span v-show={row.errorStatus !== 99999} style="color:red">{this.findRenderLabel(this.getErrorSimpleType, row.errorStatus)}</span>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.account.cusdisacountrate_source_type', { defaultValue: '来源类型' }),
                    key: 'sourceSystem',
                    render: (h, { row }) => {
                        return <div>
                            {this.findRenderLabel(this.getSourceSystem, row.sourceSystem) || '--'}
                        </div>
                    }
                },
                {
                    title: "退货Tracking",
                    key: "returnTrackingNo",
                    render: (h, { row }) => {
                        return <div>{row.returnTrackingNo || '--'}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'lineId',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId) || '--'
                },
                {
                    title: "ERPSKU",
                    key: 'skuList',
                    render: (h, { row }) => {
                        return <div>
                            {row.skuList.length > 0 ?
                                row.skuList.map((item, index) => {
                                    return <div key={index}>{item.sku + '*' + item.qty}</div>
                                }) : '--'
                            }
                        </div>
                    }
                },
                {
                    // title: this.$t('', { defaultValue: '收货状态' }) + '/' + this.$t('', { defaultValue: '确认状态' }),
                    title: this.$t('', { defaultValue: '收货状态' }),
                    render: (h, { row }) => {
                        const status = row.saleReturnPlanStatus;
                        // const confirmStatus = row.confirmStatus;
                        const { label = '', theme } = this.getPlanManageOrderStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        // const confirmLabel = this.getConfirmStatus.find(function (item) {
                        //     return item.value == confirmStatus
                        // }).label || '--';
                        // const confirmTheme = this.getConfirmStatus.find(function (item) {
                        //     return item.value == confirmStatus
                        // }).theme || '--';
                        return <div>
                            <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                            {/* <div class="margin-top-10"><vButton ghost theme={confirmTheme} size="small" class="cursor-default">{confirmLabel || '--'}</vButton></div> */}
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                    render: (h, { row }) => {
                        const wareHouse = this.getUserManageWarehouseList.filter(item => item.attach.code === row.orgWarehouseCode)
                        return <div>{wareHouse.length > 0 ? wareHouse[0].label : '--'}</div>
                    }
                },
                {
                    title: "照片",
                    render: (h, { row }) => {
                        let img = [];
                        if (row.picturesUrls) {
                            row.picturesUrls.map((item, index) => {
                                let newUrl = item + '?image_process=image/resize,w_100&x-oss-process=image/resize,w_100'
                                img.push(
                                    <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleOperates.bind(this, { url: index, urlList: row.picturesUrls }, 'image')}>
                                        <img style="width: 50px; height: 50px;" src={newUrl} />
                                    </div>
                                )
                            });
                        }
                        else {
                            img = '--'
                        }
                        return (
                            <div style="padding: 10px 0; overflow: hidden;">
                                {img.slice(0, 1)}
                            </div>
                        );
                    }
                },
                {
                    title: '最晚确认时间',
                    key: 'lastConfirmTime',
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'updatedAt',
                }];
        },
    },
};




